module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "g-bg-img-hero",
    staticStyle: {
      "background-image": "url('../../../../static/assets/include/svg/svg-bg-cfs.svg')"
    }
  }, [_c('div', {
    staticClass: "container g-py-50 g-pt-100--lg g-pb-20--lg"
  }, [_c('div', {
    staticClass: "row align-items-lg-center"
  }, [_c('div', {
    staticClass: "col-lg-6 g-mb-70 g-mb-150--sm g-mb-50--lg"
  }, [_c('div', {
    staticClass: "g-pr-15--lg"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-70 g-py-13 mr-2 g-font-size-18",
    on: {
      "click": function($event) {
        return _vm.ShowModal()
      }
    }
  }, [_vm._v("Share a Story")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 g-mb-50"
  }, [_c('div', {
    staticClass: "g-max-width-550 g-pos-rel g-pl-15--lg mx-auto"
  }, [_c('div', {
    staticClass: "g-max-width-300--sm g-pos-rel g-z-index-1 g-mb-20 g-mb-0--sm img-story-1"
  }, [_c('img', {
    staticClass: "u-shadow-v36 img-fluid g-brd-around g-brd-4 g-brd-white rounded g-mt-80",
    attrs: {
      "src": _vm.success_story_1,
      "alt": "Photo_Family2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-shadow-v36 g-max-width-300--sm g-pos-abs--sm g-top-minus-70 g-left-130 g-z-index-0 g-mb-20 g-mb-0--sm"
  }, [_c('img', {
    staticClass: "img-fluid g-brd-around g-brd-4 g-brd-white rounded",
    attrs: {
      "src": _vm.success_story_2,
      "alt": "Photo_DoctorImage5"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u-shadow-v36 g-max-width-300--sm g-pos-abs--sm g-top-65 g-right-0 g-mt-40"
  }, [_c('img', {
    staticClass: "img-fluid g-brd-around g-brd-4 g-brd-white rounded",
    attrs: {
      "src": _vm.success_story_3,
      "alt": "Photo_FamilyImage5"
    }
  })])])])])])]), _vm._v(" "), (_vm.isModalShown) ? _c('share-story-form', {
    on: {
      "close": function($event) {
        return _vm.CloseModal()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('h1', {
    staticClass: "g-font-size-45 mb-3"
  }, [_vm._v("Share a Success Story!")]), _vm._v(" "), _c('p', {
    staticClass: "g-font-size-20"
  }, [_vm._v("Have an inspiring story or best practice to improve delivery of vision services to those in need?  Please share your experiences and upload images to bring to life your contributions in your community.")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-238d857f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-238d857f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/homeData/HomeStory.vue
// module id = 488
// module chunks = 4